import { render, staticRenderFns } from "./deposit.vue?vue&type=template&id=4eda8297&scoped=true&"
import script from "./deposit.vue?vue&type=script&lang=ts&"
export * from "./deposit.vue?vue&type=script&lang=ts&"
import style0 from "./deposit.vue?vue&type=style&index=0&id=4eda8297&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eda8297",
  null
  
)

export default component.exports